import React from 'react';

interface AgentStatusCardProps {
  name: string;
  role: string;
  status: 'online' | 'offline' | 'busy' | 'not_deployed' | 'running' | 'degraded' | 'starting';
  lastActive: string;
  loading?: boolean;
}

function AgentStatusCard({ name, role, status, lastActive, loading }: AgentStatusCardProps) {
  const statusColors: Record<string, string> = {
    online: 'status-online',
    running: 'status-online',
    offline: 'status-offline',
    not_deployed: 'status-offline',
    busy: 'status-busy',
    degraded: 'status-busy',
    starting: 'status-busy',
  };

  const statusLabels: Record<string, string> = {
    online: 'Online',
    running: 'Online',
    offline: 'Offline',
    not_deployed: 'Not deployed',
    busy: 'Busy',
    degraded: 'Degraded',
    starting: 'Starting',
  };

  if (loading) {
    return (
      <div className="card">
        <div className="flex items-start justify-between">
          <div>
            <div className="animate-pulse bg-mc-border h-6 w-24 rounded mb-2"></div>
            <div className="animate-pulse bg-mc-border h-4 w-32 rounded"></div>
          </div>
          <div className="animate-pulse bg-mc-border h-6 w-16 rounded"></div>
        </div>
        <div className="mt-4 pt-4 border-t border-mc-border">
          <div className="animate-pulse bg-mc-border h-4 w-40 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-xl font-bold">{name}</h3>
          <p className="text-mc-muted text-sm">{role}</p>
        </div>
        <div className="flex items-center gap-2">
          <div className={`status-dot ${statusColors[status]}`}></div>
          <span className="text-sm">{statusLabels[status]}</span>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-mc-border">
        <p className="text-sm text-mc-muted">
          <span className="text-mc-text">{lastActive}</span>
        </p>
      </div>
    </div>
  );
}

export default AgentStatusCard;
